import { TemplateDownloadBanner } from "@/components/template-download-banner";
import { SUPPLIER_TEMPLATE_URL } from "@/constants/templates";

export default function SupplierTemplateBanner() {
  return (
    <TemplateDownloadBanner
      title="Plantilla de Proveedores (Excel)"
      description="Descargá el Excel de ejemplo. Usá los mismos Rubros y Subrubros que en Productos para asegurar el match."
      href={SUPPLIER_TEMPLATE_URL}
      buttonLabel="Abrir plantilla de Proveedores"
    />
  );
}

